// src/components/TrendV2/TrendV2Monitor.tsx
import { useTrackTrendV2Cache } from '@/hooks/useTrackTrendV2Cache'
import { TrendV2TrackingItem } from '@/constants/trend_v2'

interface TrendV2MonitorProps {
  item: TrendV2TrackingItem
}

const TrendV2Monitor: React.FC<TrendV2MonitorProps> = ({ item }) => {
  const { isMonitoring: _isMonitoring } = useTrackTrendV2Cache({
    messageId: item.messageId,
    conversationId: item.conversationId,
    enabled: true, // Always enabled
    onComplete: () => {},
  })

  return null
}

export default TrendV2Monitor
